import type { AllRouteEndpoints } from "../routeTypes";
export const apiCalculatedFiltersAppGroupId = "/api/calculated_filters/:app_group_id";

export const postApiCalculatedFiltersAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  "/api/calculated_filters/:app_group_id",
];
